module.exports = __webpack_public_path__ + "static/media/live.373b221f.svg";